import AxiosInstance from "../config/AxiosInstance";

// InnovX staff access (core-api /api/platform/staff); the API checks the caller may manage it.
export interface PlatformStaffAccess {
    userId: string;
    supportRoleId: string | null;
    supportRoleName?: string | null;
    isActive: boolean;
}

const staffPath = (userId: string) => '/api/platform/staff/' + encodeURIComponent(userId);

const getPlatformStaff = async (userId: string) => {
    const { data } = await AxiosInstance.get(staffPath(userId));
    return { data };
};

// null revokes the grant; any change ends the person's sessions.
const updatePlatformStaff = async (userId: string, supportRoleId: string | null) => {
    const { data } = await AxiosInstance.put(staffPath(userId), { supportRoleId });
    return { data };
};

export {
    getPlatformStaff,
    updatePlatformStaff
}
